// File: app.service.ts
// Author: Joseph M Diaz
// Date: 5/8/2017
// Desc: Root module for the app.
// Other Contributors:

import { Injectable, Output, EventEmitter } from '@angular/core';

import { CgpAppBarService } from './shared/cgp-app-bar/cgp-app-bar.service';
import { CgpBreadcrumbsService } from './shared/cgp-breadcrumbs/cgp-breadcrumbs.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppService {
    @Output() fullScreenToggled: EventEmitter<any> = new EventEmitter();
    @Output() sideNavToggled: EventEmitter<any> = new EventEmitter();

    viewTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
    appComponent;
    fullScreenState = {
        sideNavVisible: null
    };

    constructor(private readonly cgpAppBarService: CgpAppBarService, private readonly cgpBreadcrumbsService: CgpBreadcrumbsService) { }

    isFullScreen() {
        return this.appComponent.isFullScreen;
    }

    toggleFullScreen() {
        const isFullScreen = this.appComponent.isFullScreen;
        const sideNavVisible = this.appComponent.sidenavVisible;

        if (!isFullScreen) {
            this.fullScreenState.sideNavVisible = sideNavVisible;

            this.cgpAppBarService.hide();
            this.cgpBreadcrumbsService.hide();
            this.appComponent.sidenavVisible = false;
        } else {
            this.cgpAppBarService.show();
            this.cgpBreadcrumbsService.show();
            this.appComponent.sidenavVisible = this.fullScreenState.sideNavVisible;
        }

        this.appComponent.isFullScreen = !this.appComponent.isFullScreen;
        this.fullScreenToggled.emit(this.appComponent.isFullScreen);
    }

    toggleSidenav() {
        this.appComponent.sidenavVisible = !this.appComponent.sidenavVisible;
        this.sideNavToggled.emit(this.appComponent.sidenavVisible);
    }

    logout() {
        if (this.appComponent.isFullScreen) {
            this.toggleFullScreen();
        }
        this.appComponent.sidenavVisible = false;
    }
}
